(() => {
  const AUDIENCE_KEY = 'filter.p.m.custom.audience_reference';

  const normalize = (value) => (value || '')
    .trim()
    .toLocaleLowerCase('de')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/ü/g, 'u')
    .replace(/ß/g, 'ss')
    .replace(/\s+/g, ' ');

  const withAudience = (panel, path) => {
    const target = new URL(path, window.location.origin);
    const source = panel.querySelector('.ps-mega__all-link[href]');
    if (source) {
      try {
        const current = new URL(source.getAttribute('href'), window.location.origin);
        current.searchParams.getAll(AUDIENCE_KEY).forEach((value) => {
          target.searchParams.append(AUDIENCE_KEY, value);
        });
      } catch (error) {
        // Link remains usable without an audience filter.
      }
    }
    return `${target.pathname}${target.search}${target.hash}`;
  };

  const decodeVisualTitles = (context) => {
    context.querySelectorAll('.ps-mega__visual-overlay strong').forEach((title) => {
      const value = title.textContent || '';
      if (!/&(?:amp|quot|apos|lt|gt|#\d+|#x[0-9a-f]+);/i.test(value)) return;
      const decoder = document.createElement('textarea');
      decoder.innerHTML = value;
      title.textContent = decoder.value;
    });
  };

  const ensureCoatHierarchy = (context) => {
    context.querySelectorAll('.ps-mega__panel[data-panel$=":bekleidung"] .ps-mega__category-groups').forEach((groups) => {
      const panel = groups.closest('.ps-mega__panel');
      if (!panel) return;

      [...groups.querySelectorAll(':scope > .ps-mega__category-group')].forEach((group) => {
        const label = normalize(group.querySelector(':scope > h3')?.textContent);
        if (label === 'regenmantel' || label === 'wintermantel') group.remove();
      });

      let coatGroup = [...groups.querySelectorAll(':scope > .ps-mega__category-group')]
        .find((group) => normalize(group.querySelector(':scope > h3')?.textContent) === 'mantel');

      if (!coatGroup) {
        coatGroup = document.createElement('div');
        coatGroup.className = 'ps-mega__category-group';
        coatGroup.dataset.psCanonicalCoats = 'true';

        const heading = document.createElement('h3');
        const headingLink = document.createElement('a');
        headingLink.textContent = 'Mäntel';
        heading.appendChild(headingLink);
        coatGroup.appendChild(heading);

        const jackets = [...groups.querySelectorAll(':scope > .ps-mega__category-group')]
          .find((group) => normalize(group.querySelector(':scope > h3')?.textContent) === 'jacken');
        if (jackets) jackets.insertAdjacentElement('afterend', coatGroup);
        else groups.appendChild(coatGroup);
      }

      const headingLink = coatGroup.querySelector(':scope > h3 a') || (() => {
        const heading = coatGroup.querySelector(':scope > h3') || coatGroup.appendChild(document.createElement('h3'));
        const link = document.createElement('a');
        heading.textContent = '';
        heading.appendChild(link);
        return link;
      })();
      headingLink.textContent = 'Mäntel';
      headingLink.href = withAudience(panel, '/collections/mantel');

      [...coatGroup.querySelectorAll(':scope > a')].forEach((link) => link.remove());
      [
        ['Regenmäntel', '/collections/regenmantel'],
        ['Wintermäntel', '/collections/wintermantel']
      ].forEach(([label, path]) => {
        const link = document.createElement('a');
        link.textContent = label;
        link.href = withAudience(panel, path);
        coatGroup.appendChild(link);
      });
    });
  };

  const rebuildBrandIndex = (context) => {
    context.querySelectorAll('[data-panel$=":marken"] .ps-mega__brand-directory').forEach((directory) => {
      if (directory.dataset.psCuratedBrandDirectory === 'true') return;

      const sectionsContainer = directory.querySelector('.ps-mega__brand-sections');
      if (!sectionsContainer) return;

      const linksByLetter = new Map();
      sectionsContainer.querySelectorAll('.ps-mega__brand-link, a[data-brand-link]').forEach((link) => {
        const name = (link.dataset.brandName || link.textContent || '').trim();
        const letter = name.charAt(0).toLocaleUpperCase('de');
        if (!/^[A-Z]$/.test(letter)) return;
        if (!linksByLetter.has(letter)) linksByLetter.set(letter, []);
        linksByLetter.get(letter).push(link);
      });

      const fragment = document.createDocumentFragment();
      'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach((letter) => {
        const section = document.createElement('div');
        section.className = 'ps-mega__brand-section';
        section.dataset.psBrandLetter = letter;

        const heading = document.createElement('h3');
        heading.textContent = letter;
        section.appendChild(heading);

        const links = (linksByLetter.get(letter) || []).sort((a, b) =>
          (a.dataset.brandName || a.textContent || '').localeCompare(
            b.dataset.brandName || b.textContent || '',
            'de'
          )
        );

        if (!links.length) section.classList.add('ps-mega__brand-section--empty');
        links.forEach((link) => section.appendChild(link));
        fragment.appendChild(section);
      });

      sectionsContainer.replaceChildren(fragment);
      directory.dataset.psAlphabetComplete = 'true';
    });
  };

  const applyPeakStyleMegaMenuAdjustments = (root = document) => {
    const context = root && root.querySelectorAll ? root : document;

    decodeVisualTitles(context);

    context.querySelectorAll('.ps-mega__activity-card[href*="activity-schneeschuhwandern"]').forEach((card) => {
      const label = card.querySelector(':scope > span:last-child');
      if (!label) return;
      label.innerHTML = 'Schneeschuh-<br>Wandern';
      label.dataset.psActivityLabel = 'schneeschuhwandern';
      card.setAttribute('aria-label', 'Schneeschuh-Wandern');
    });

    context.querySelectorAll('.ps-mega__eyebrow').forEach((heading) => {
      const text = heading.textContent.trim();
      const match = text.match(/^Entdecke\s+(?!unsere\b)(.+)$/i);
      if (match) heading.textContent = `Entdecke unsere ${match[1]}`;
    });

    context.querySelectorAll('.ps-mega__alphabet').forEach((alphabet) => {
      alphabet.setAttribute('aria-hidden', 'true');
    });

    ensureCoatHierarchy(context);
    rebuildBrandIndex(context);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyPeakStyleMegaMenuAdjustments(document), { once: true });
  } else {
    applyPeakStyleMegaMenuAdjustments(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    applyPeakStyleMegaMenuAdjustments(event.target);
  });

  document.addEventListener('mouseenter', (event) => {
    if (event.target.closest?.('.ps-mega')) applyPeakStyleMegaMenuAdjustments(document);
  }, true);
})();